module.exports = __webpack_public_path__ + "img/logo.a566ab64.png";